// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2exJs","imageUploader":"EGiftCard_imageUploader__qUSyC"};